module.exports = __webpack_public_path__ + "img/202510_02.c3f616e5.png";